define([
    'base/utils/cookie',
    'base/utils/iamHttpService',
    'language/resource',
    'authui/iamUtils',
    'base/utils/utility'
], function (cookieOp, iamHttpService, i18n, iamUtils, utils) {
    'use strict';

    var ctrl = function($scope, securityPolicy) {
        $scope.i18n = i18n;
        document.title = i18n('titles.setPassword');
        $scope.model = {
            width: '100%',
            pwdTip: utils.buildTip(null, null, null, null, null, i18n),
            height: iamUtils.layout.inputFieldHeight,
            type: 'password',
            passwordId: 'passwordId',
            confirmPasswordId: 'confirmPasswordId',
            password: '',
            confirmPassword: '',
            lowPasswords: [],
            maxPwdLength: securityPolicy.passwordpolicy.password_maxlen,
            'lastWeakPasswdLvl': '',
            'validTip': '/authui/public/custom/images/default.png',
            'validSuc': require('custom/images/right.png'),
            'validFail': require('custom/images/wrong.png'),
            onPasswordFocus: function(){
                var value =  $('#' + $scope.model.passwordId).widget().getValue();
                if (value !== ''){
                    validatePwdAll(value, securityPolicy, $scope);
                }else {
                    utils.addErrorTip(i18n('blankTxt'), '#PasswordError');
                }
            },
            onPasswordChange: function (event, value) {
                if ($scope.model.lowPasswords.indexOf(value) > -1) {
                    $scope.model.isWeakPassword = true;
                } else {
                    $scope.model.isWeakPassword = false;
                }
                $scope.model.confirmPassword = '';
                $scope.$apply();
                var removeObj = utils.getInputObj($scope.model.passwordId);
                removeObj.removeClass('valid_error_input');
                utils.removeErrorInfo('#PasswordError');
                validatePwdAll(value, securityPolicy, $scope);
            },
            passwordBlur: function () {
                $scope.model.isWeakPassword = false;
                var value = $('#' + $scope.model.passwordId).widget().getValue();
                var retObj = utils.validatePasswdChar(value);
                var retMinLenth = value.length >= $scope.model.pwdMinLen;
                var retObjCharTimes = utils.maxRptCharTimes(value,$scope.model.contSameCharLen);
                var containsCharsResult = utils.validatePasswdChar(value, securityPolicy.passwordpolicy.password_char_combination);
                if (retObj && retMinLenth && retObjCharTimes && containsCharsResult) {
                    passwdAsynCheck($scope);
                    $scope.model.passwdDtd.fail(function() {
                        password2error($scope);
                        if ($scope.model.passwdErr !== i18n('pwdNotUsernameOrInvert')){
                            utils.addErrorTip($scope.model.passwdErr, '#PasswordError');
                        }
                        return;
                    }).done(function() {
                        var removeObj = utils.getInputObj($scope.model.passwordId);
                        removeObj.removeClass('valid_error_input');
                    });
                } else {
                    password2error($scope);
                }
            },
            onConfirmPasswordBlur: function () {
                var value = $('#' + $scope.model.confirmPasswordId).widget().getValue();
                var retObj = iamUtils.directValidator.confirmPwd(value, $scope.model.passwordId);
                if (retObj.result) {
                    utils.removeErrorInfo('#confirmPasswordError');
                    var removeObj = utils.getInputObj($scope.model.confirmPasswordId);
                    removeObj.removeClass('valid_error_input');
                }
                else {
                    //$("#" + $scope.model.confirmPasswordId).addClass("valid_error_input");
                    var pwdObj = $('#' + $scope.model.confirmPasswordId);//兼容tiny1.48.1和之前的老版本
                    if (pwdObj[0].tagName === 'INPUT') {
                        pwdObj.addClass('valid_error_input');
                    }else {
                        pwdObj.find('input').addClass('valid_error_input');
                    }
                    utils.addErrorTip(retObj.errorInfo, '#confirmPasswordError');
                }
            }
        };
        getPasswordPolicy($scope, iamHttpService,securityPolicy);
        $scope.model.pwdMinLenDtd.done(function() {
            var contSameCharLenTips = null;
            if($scope.model.contSameCharLen !== 0){
                contSameCharLenTips = utils.i18nFormat(i18n('passwordPolicy.errorMsgOfRptChar'), $scope.model.contSameCharLen);
            }
            $scope.model.pwdTip = utils.buildTip(utils.i18nFormat(i18n('minMaxLenTxt'), $scope.model.pwdMinLen, securityPolicy.passwordpolicy.password_maxlen) , utils.i18nFormat(i18n('passwordChars'), securityPolicy.passwordpolicy.password_char_combination),
                contSameCharLenTips,i18n('pwdNotUsernameOrInvert'),null, i18n);
            $scope.$apply();
        });
        $scope.model.equalValidate = iamUtils.validator.confirmPwd('passwordId');
        $scope.model.keyPress=function(event){
            iamUtils.enterEvent(event, $scope.onSubmitClick);
        };
        $scope.onSubmitClick = function () {
            if ($scope.model.password === '' || $scope.model.confirmPassword === '') {
                return;
            }
            if ($('#submitBtn').hasClass('btnDisabled')) {
                return;
            }
            if (hasErrorInfo($scope)) {
                return;
            }
            $('#submitBtn').addClass('btnDisabled');
            $scope.model.passwdDtd.fail(function() {
                password2error($scope);
                iamUtils.unifyValid.focusFirst($('#formUl'));
                $('#submitBtn').removeClass('btnDisabled');
                return;
            }).done(function() {
                var productType = window.productType;
                if (productType == 'HWS') {
                    iamHttpService.get({
                        url: '/authui/logout',
                        mask: true
                    }).then(function (data) {
                        post('/authui/welcomeLogin' + window.location.search, {
                            passvvord: $('#' + $scope.model.passwordId).widget().getValue(),
                            confirmPvvd: $('#' + $scope.model.confirmPasswordId).widget().getValue(),
                            pvvdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue())
                        });
                    }, function () {
                        post('/authui/welcomeLogin' + window.location.search, {
                            passvvord: $('#' + $scope.model.passwordId).widget().getValue(),
                            confirmPvvd: $('#' + $scope.model.confirmPasswordId).widget().getValue(),
                            pvvdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue())
                        });
                    });
                } else {
                    post('/authui/welcomeLogin' + window.location.search, {
                        passvvord: $('#' + $scope.model.passwordId).widget().getValue(),
                        confirmPvvd: $('#' + $scope.model.confirmPasswordId).widget().getValue(),
                        pvvdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue())
                    });
                }
            });
        };

        $scope.onCancelClick = function(){
            var service = iamUtils.getUrlParams().service;
            service !== undefined ? window.location.href = '/authui/logout?service=' + service : window.location.href = '/authui/logout';
        };
        setErrorMsg();
    };

    function hasErrorInfo($scope) {
        var errorIds = ['passwordError', 'confirmPasswordError'];
        var inputIds = ['passwordId','confirmPasswordId'];
        $scope.model.passwordBlur();
        $scope.model.onConfirmPasswordBlur();
        for (var index in errorIds) {
            if($('#' + errorIds[index])[0] ===  undefined){
                for (var index in inputIds){
                    if($('#' + inputIds[index] + '>input').hasClass('valid_error_input')){
                        return true;
                    }
                }
            }
        }
        return false;
    }
    
    function validatePwdAll(value, securityPolicy, $scope) {
        var password = value;
        var isBlank = value.length == 0;
        var minLenResult = password.length >= securityPolicy.passwordpolicy.password_minlen && password.length <= 32;
        var containsCharsResult = utils.validatePasswdChar(password, securityPolicy.passwordpolicy.password_char_combination);
        var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);
        var validatePasswdName = utils.validatePasswdName(password, $scope.model.name) && utils.validatePasswdNameSHA256(password, $scope.model.name);
        
        if(!$scope.model.isWeakPassword || !minLenResult){
            utils.setPwdLevel4Hws('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', password, i18n, securityPolicy.passwordpolicy.password_minlen);
        } else {
            utils.setPwdLvlByLvl('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', 'low', i18n );
        }
        changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope);
    }
        
    function changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope) {
        change2ResultEach($scope, 'minLenId', minLenResult);
        change2ResultEach($scope, 'containsCharsId', containsCharsResult);
        change2ResultEach($scope, 'maxSameCharsId', maxSameCharsResult);
        change2ResultEach($scope, 'notNameId', validatePasswdName);
        if (isBlank) {
            $('#containsCharsId').attr('src', $scope.model.validTip);
            $('#minLenId').attr('src', $scope.model.validTip);
            $('#maxSameCharsId').attr('src', $scope.model.validTip);
            $('#notNameId').attr('src', $scope.model.validTip);
        }
    }
    function change2ResultEach($scope, id, result) {
        if (result) {
            $('#' + id).attr('src', $scope.model.validSuc);
        } else {
            $('#' + id).attr('src', $scope.model.validFail);
        }
    }

    function passwdAsynCheck($scope){
        var dtd = $.Deferred();
        iamHttpService.post({
            url: '/authui/passwdAsynCheck',
            params: {
                domain:$scope.model.domain,
                username:$scope.model.name,
                pvvd:$scope.model.password,
                isCheckByName:'true'
            }
        }).then(function(data){
            if (data.result === true){
                $scope.model.passwdErr = '';
                $scope.model.lastWeakPasswdLvl = '';
                dtd.resolve();
            }else{
                $scope.model.lastWeakPasswdLvl = 'low';
                if (data.error_code === '1000'){
                    $scope.model.passwdErr = i18n('invalidInput');
                }else if (data.error_code === '1001'){
                    $scope.model.passwdErr = i18n('pwdNotUsernameOrInvert');
                }else if (data.error_code === '1002'){
                    $scope.model.passwdErr = i18n('pwdNotContsMobileOrEmail');
                }else if (data.error_code === '1003'){
                    $scope.model.passwdErr = i18n('pwdWeak');
                    $scope.model.lowPasswords.push($scope.model.password);
                }else if (data === 'checkVerifyCode4Forbidden'){
                    $scope.model.passwdErr = i18n('freqLocked');
                }else{
                    $scope.model.passwdErr = i18n('systemException');
                }
                dtd.reject();
            }
        },function(){
            $scope.model.passwdErr = i18n('systemException');
            dtd.reject();
        });
        $scope.model.passwdDtd = dtd.promise();
    }

    function password2error($scope) {
        var pwdObj = $('#' + $scope.model.passwordId);//兼容tiny1.48.1和之前的老版本
        if (pwdObj[0].tagName === 'INPUT') {
            pwdObj.addClass('tiny-input-text valid_error_input');
        }else {
            pwdObj.find('input').addClass('tiny-input-text valid_error_input');
        }
    }

    function setErrorMsg() {
        var url = '' + window.location
        var errorMsgObj = {
            '401': i18n('selfManage.alertTip'),
            '403': i18n('resetPwd.resetFailed'),
            '402': i18n('pwdSame'),
            '406': i18n('invalidInput')
        };

        var paraStr = window.location.search;
        var paraArray = paraStr.split('&');
        for(var i=0; i<paraArray.length; i++)
        {
            if (paraArray[i].indexOf('?actionErrors') === 0 || paraArray[i].indexOf('actionErrors') === 0)
            {
                $('#errorMsg').html(errorMsgObj[decodeURIComponent(paraArray[i].split('=')[1])]);
            }
        }
    }

    function post(URL, PARAMS) {
        var temp = document.createElement('form');
        temp.action = URL;
        temp.method = 'post';
        temp.style.display = 'none';
        for (var x in PARAMS) {
            var opt = document.createElement('textarea');
            opt.name = x;
            opt.value = PARAMS[x];
            temp.appendChild(opt);
        }
        document.body.appendChild(temp);
        temp.submit();
        return temp;
    }

    function getPasswordPolicy($scope, iamHttpService, securityPolicy) {
        var dtd = $.Deferred();
        iamHttpService.get({
            url: '/rest/authui/welcome/getPassvvdPolicy',
            mask: true
        }).then(function (data) {
            if(data.retinfo === 'success')
            {
                $scope.model.pwdMinLen = data.pwdMinLen;
                $scope.model.name = data.name;
                $scope.model.contSameCharLen = data.contSameCharLen;
                $scope.model.domain = data.domain;

                securityPolicy.passwordpolicy.password_minlen = data.pwdMinLen;
                securityPolicy.passwordpolicy.password_char_combination = data.password_char_combination;

                $scope.$apply();
                dtd.resolve();
            }
            else
            {
                iamUtils.redirect2Login();
                dtd.reject();
            }
            $('#' + $scope.model.passwordId).widget().option('focused', true);
        }, function (data) {
            iamUtils.redirect2Login();
            dtd.reject();
        });
        $scope.model.pwdMinLenDtd = dtd.promise();
    }

    ctrl = ['$scope', 'securityPolicy', ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.welcomeLogin.ctrl', ctrl);

    return ctrl;
});



// WEBPACK FOOTER //
// ./public/hws/js/welcomeemail/controllers/resetpwdController.js